import { render, staticRenderFns } from "./VinculateMP.vue?vue&type=template&id=59ae4b88&scoped=true&"
import script from "./VinculateMP.vue?vue&type=script&lang=js&"
export * from "./VinculateMP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ae4b88",
  null
  
)

export default component.exports